/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cna_Field_Call_TimeInputs */

const en_cna_field_call_time = /** @type {(inputs: Cna_Field_Call_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time of the call`)
};

const ja_cna_field_call_time = /** @type {(inputs: Cna_Field_Call_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`発信時刻`)
};

const fr_cna_field_call_time = /** @type {(inputs: Cna_Field_Call_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure de l'appel`)
};

const de_cna_field_call_time = /** @type {(inputs: Cna_Field_Call_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhrzeit des Anrufs`)
};

/**
* | output |
* | --- |
* | "Time of the call" |
*
* @param {Cna_Field_Call_TimeInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cna_field_call_time = /** @type {((inputs?: Cna_Field_Call_TimeInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cna_Field_Call_TimeInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cna_field_call_time(inputs)
	if (locale === "ja") return ja_cna_field_call_time(inputs)
	if (locale === "fr") return fr_cna_field_call_time(inputs)
	return de_cna_field_call_time(inputs)
});